export const OFFICE_PDF_FALLBACK_TIMEOUT_MS = 10_000
export const OFFICE_INITIAL_LOAD_FALLBACK_TIMEOUT_MS = 60_000
export const MAX_REMOTE_OFFICE_BROWSER_FILE_CACHE_ENTRIES = 10
export const MAX_REMOTE_OFFICE_BROWSER_FILE_CACHE_BYTES = 160 * 1024 * 1024
